import { render } from "./WhatsappButton.vue?vue&type=template&id=2921a195&scoped=true"
import script from "./WhatsappButton.vue?vue&type=script&lang=js"
export * from "./WhatsappButton.vue?vue&type=script&lang=js"

import "./WhatsappButton.vue?vue&type=style&index=0&id=2921a195&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2921a195"]])

export default __exports__